import { type ChangeEvent, type MouseEvent, useRef } from 'react';
import { FieldError, Icon, OptionIcon } from '@recargas-dominicanas/core/components';
import { style } from './image-field.module.css';
import clsx from 'clsx';
import type { Field } from '@recargas-dominicanas/core/hooks';

interface Props {
  className?: string;
  label?: string;
  image?: string;
  name?: string;
  placeholder?: string;
  field: Field<File | undefined>;
}

export function ImageField(props: Props) {

  const {
    className,
    label,
    image,
    name,
    placeholder,
    field
  } = props;

  const uploadInput = useRef<HTMLInputElement>(null);

  function handleClick() {
    uploadInput.current?.click();
  }

  function handleUploadInputChange(event: ChangeEvent<HTMLInputElement>) {
    field.update(event.target.files?.[0]);
    field.validate(event.target.files?.[0]);
  }

  function handleClear(event?: MouseEvent<HTMLDivElement>) {
    event?.stopPropagation();
    field.clear();
  }

  return (
    <div className={clsx(style.container, className)}>
      <div className={style.label}>{label}</div>
      <div 
        className={style.content}
        onClick={handleClick}>
        {!field.value && !image &&
          <Icon
            className={style.icon} 
            icon='add_photo_alternate'/>
        }
        {(field.value || image) &&
          <img
            className={style.image}
            src={field.value ? URL.createObjectURL(field.value) : `${process.env.APP_IMAGES_DOMAIN}/${image}`}/>
        }
        <div className={style.name}>
          {field.value?.name ?? name ?? <span className={style.placeholder}>{placeholder}</span>}
        </div>
        {field.value &&
          <OptionIcon 
            className={style.clearIcon}
            icon='clear'
            onClick={handleClear}/>
        }
      </div>
      {field.invalid &&
        <FieldError message='Seleccione una imagen'/>
      }
      <input
        className={style.uploadInput}
        type='file'
        accept='.png,.jpg,.jpeg,.svg'
        ref={uploadInput}
        onChange={handleUploadInputChange}/>
    </div>
  );
}
